/**
 * Creates a CSS media query based on the breakpoint arguments provided
 *
 * @param {string} type One of 'above' or 'below'
 * @param {string} value Can be a css size value ('300px') or a theme breakpoint key ('lg')
 * @param [theme] A theme that matches the shape of somosTheme from this library
 *
 * @returns {string} CSS media query
 */
const createBreakpoint = (type, value, theme = {}) => {
   const breakpoints = theme.breakpoints || {};
   const queryValue = breakpoints[value] || value;
   if (type === 'above') {
      return `@media (min-width: ${queryValue})`;
   }
   return `@media (max-width: ${queryValue})`;
};

export { createBreakpoint };
